import { z } from 'zod';
import { esquemaId } from './comunes.js';
import { esquemaContraseña } from './usuario.js';
/**
 * Identidad de la paciente en el portal (F4.2, PORTAL-01, ADR-007, plan §8.1).
 *
 * - La cuenta es otra identidad, no un `Usuario`. Se vincula a una paciente SOLO
 *   por invitacion del consultorio: nunca por coincidencia de correo, nombre o
 *   fecha de nacimiento.
 * - Activar exige dos cosas: el enlace que llega al correo (prueba el canal) y
 *   el codigo que el consultorio entrega en persona (la verificacion de
 *   identidad que el consultorio hace). Controlar un correo no prueba
 *   identidad clinica.
 */
export const ALCANCES_DE_PORTAL = [
    'resultados',
    'citas',
    'documentos',
    'planes',
    'seguimiento',
    'mensajes',
];
export const NOMBRE_DE_ALCANCE = {
    resultados: 'Resultados publicados',
    citas: 'Citas',
    documentos: 'Documentos autorizados',
    planes: 'Planes e indicaciones',
    seguimiento: 'Registrar mediciones y responder cuestionarios',
    mensajes: 'Mensajes con el equipo',
};
/**
 * Version de los terminos y el aviso de privacidad del portal que se aceptan al
 * activar. BORRADOR: el texto lo fija el dueño con asesoria legal (F0.5).
 */
export const VERSION_TERMINOS_PORTAL = 'portal-v1-borrador';
const correo = z.string().trim().toLowerCase().email('Correo inválido').max(200);
/**
 * Representacion (F4.4, PORTAL-02, plan §8.7): una persona entra al portal POR
 * la paciente (madre, padre, tutor legal, cuidador). Tiene su propia cuenta,
 * cada accion dice a quien representa y la autoria es suya, no de la paciente.
 * Vence: al llegar `vigenteHasta` el acceso se corta solo.
 */
export const RELACIONES_DE_REPRESENTACION = [
    'madre',
    'padre',
    'tutor-legal',
    'cuidador',
    'otra',
];
export const NOMBRE_DE_RELACION = {
    madre: 'Madre',
    padre: 'Padre',
    'tutor-legal': 'Tutor legal',
    cuidador: 'Cuidador',
    otra: 'Otra relación',
};
const dia = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Fecha AAAA-MM-DD');
export const esquemaRepresentacion = z
    .object({
    nombre: z.string().trim().min(2, 'Nombre de quien representa').max(160),
    relacion: z.enum(RELACIONES_DE_REPRESENTACION),
    /** Que documento se reviso (p. ej. «acta de nacimiento»), no el documento. */
    documentoDeSoporte: z.string().trim().min(3, 'Indique el documento revisado').max(200),
    vigenteHasta: dia,
})
    .strict();
export const esquemaRenovarRepresentacion = z
    .object({
    vigenteHasta: dia,
    motivo: z.string().trim().min(10).max(500),
})
    .strict();
export const esquemaInvitarAPortal = z
    .object({
    correo,
    alcance: z.array(z.enum(ALCANCES_DE_PORTAL)).min(1, 'Elija al menos un alcance').max(10),
    diasDeVigencia: z.number().int().min(1).max(14).default(7),
    /** Si la invitacion es para quien representa a la paciente, no para ella. */
    representacion: esquemaRepresentacion.optional(),
})
    .strict();
export const esquemaActivarPortal = z
    .object({
    token: z.string().min(20).max(200),
    codigo: z.string().regex(/^\d{6}$/, 'El código tiene 6 dígitos'),
    contrasena: esquemaContraseña,
    terminos: z.literal(VERSION_TERMINOS_PORTAL),
})
    .strict();
export const esquemaIngresoPortal = z
    .object({ correo, contrasena: z.string().min(1).max(200) })
    .strict();
export const esquemaRecuperarPortal = z.object({ correo }).strict();
export const esquemaConfirmarRecuperacionPortal = z
    .object({ token: z.string().min(20).max(200), contrasena: esquemaContraseña })
    .strict();
export const esquemaElegirEspacio = z.object({ vinculoId: esquemaId }).strict();
//# sourceMappingURL=portalPaciente.js.map